import React, { FC, useState } from "react";
import { Card, CardContent } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { useRouter } from "next/router";
import { NextSwiperArrow, PrevSwiperArrow } from "@/components/icons";

interface TopVisitedDestinationsProps {
  data: {
    heading: string;
    destinations: {
      id: number;
      title: string;
      description: string;
      background: string;
      heading: string;
    }[];
  };
}

const TopVisitedDestinations: FC<TopVisitedDestinationsProps> = ({ data }) => {
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);
  const router = useRouter();
  const isRtl = router.locale === "ar";
  const handleSwiper = (swiper: any) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  const handleSlideChange = (swiper: any) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };

  return (
    <div className="flex flex-col w-full max-w-[1328px] items-start c-lg:gap-12 gap-6  mx-auto  relative p-4">
      <div className="flex items-center justify-between relative self-stretch w-full">
        <h1 className=" w-fit font-bold  c-lg:text-4xl text-2xl ">
          {data.heading}{" "}
        </h1>
      </div>

      <div
        className={`swiper-button-prev-custom swiper-button-prev-custom-B transition-opacity duration-200 ${
          isBeginning ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      >
        <PrevSwiperArrow />
      </div>
      <div
        className={`swiper-button-next-custom swiper-button-next-custom-B  transition-opacity duration-200 ${
          isEnd ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
      >
        <NextSwiperArrow />
      </div>

      <div className="overflow-hidden max-w-[1312px]">
        <Swiper
          dir={isRtl ? "rtl" : "ltr"}
          key={isRtl ? "rtl" : "ltr"}
          spaceBetween={16}
          slidesPerView={1}
          slidesPerGroup={1}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 16,
              centeredSlides: true,
            },
            768: {
              slidesPerView: 2.5,
              spaceBetween: 16,
            },
            1024: {
              slidesPerView: 3.4,
              spaceBetween: 16,
            },
          }}
          navigation={{
            nextEl: ".swiper-button-next-custom-B",
            prevEl: ".swiper-button-prev-custom-B",
          }}
          modules={[Navigation]}
          className="mySwiper1"
          onSwiper={handleSwiper}
          onSlideChange={handleSlideChange}
        >
          {data.destinations.map((card) => (
            <SwiperSlide key={card.id}>
              <Card className="sm:w-[376px]  w-[90vw]  h-[349px] border !shadow-none !border-solid !border-[#d8dcde] !rounded-xl my-1">
                <CardContent className="flex flex-col items-start gap-8 !p-0 h-full">
                  <div className="relative w-full h-56">
                    <div
                      className="relative w-full h-56 bg-cover bg-[50%_50%]"
                      style={{ backgroundImage: `url(${card.background})` }}
                    >
                      <div className="relative h-56">
                        <div className="absolute c-lg:w-[327px] top-[119px] left-[22px] font-extrabold text-white text-[28px] leading-10">
                          {card.heading}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col w-[342.4px] items-start gap-[5.6px] px-4 pb-4">
                    <h3 className="w-full font-semibold  text-base leading-6">
                      {card.title}
                    </h3>

                    <div className="flex flex-col items-start relative self-stretch w-full">
                      <p className="relative self-stretch font-normal  text-sm leading-5">
                        {card.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default TopVisitedDestinations;
